import { apiClient, APIResponse, toFormData, extractApiError, buildQuery } from './api';

function hasFile(payload) {
  return Object.values(payload || {}).some(
    (value) =>
      value instanceof Blob ||
      (value && typeof value === 'object' && 'size' in value && 'name' in value),
  );
}

export const goalsAPI = {
  async list(params) {
    try {
      const { data } = await apiClient.get(`/goals/${buildQuery(params)}`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar os objectivos.'),
      );
    }
  },

  async retrieve(id) {
    try {
      const { data } = await apiClient.get(`/goals/${id}/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar o objectivo.'),
      );
    }
  },

  async create(payload) {
    try {
      const config = hasFile(payload)
        ? { headers: { 'Content-Type': 'multipart/form-data' } }
        : undefined;
      const body = hasFile(payload) ? toFormData(payload) : payload;
      const { data } = await apiClient.post('/goals/', body, config);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível criar o objectivo.'),
      );
    }
  },

  async update(id, payload) {
    try {
      const config = hasFile(payload)
        ? { headers: { 'Content-Type': 'multipart/form-data' } }
        : undefined;
      const body = hasFile(payload) ? toFormData(payload) : payload;
      const { data } = await apiClient.patch(`/goals/${id}/`, body, config);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível atualizar o objectivo.'),
      );
    }
  },

  async remove(id) {
    try {
      await apiClient.delete(`/goals/${id}/`);
      return APIResponse.success(null);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível remover o objectivo.'),
      );
    }
  },

  async getProgress(id) {
    try {
      const { data } = await apiClient.get(`/goals/${id}/progress/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar o progresso.'),
      );
    }
  },

  async complete(id) {
    try {
      const { data } = await apiClient.post(`/goals/${id}/complete/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível concluir o objectivo.'),
      );
    }
  },

  async cancel(id) {
    try {
      const { data } = await apiClient.post(`/goals/${id}/cancel/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível cancelar o objectivo.'),
      );
    }
  },

  async uploadImage(id, file) {
    try {
      const body = toFormData({ image: file });
      const { data } = await apiClient.post(`/goals/${id}/image/`, body, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar a imagem.'),
      );
    }
  },

  async suggestPriority() {
    try {
      const { data } = await apiClient.get('/goals/suggest-priority/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível obter a sugestão.'),
      );
    }
  },

  async listMilestones(params) {
    try {
      const { data } = await apiClient.get(
        `/goal-milestones/${buildQuery(params)}`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar os marcos.'),
      );
    }
  },

  async addChecklistItem(goalId, title) {
    try {
      const { data } = await apiClient.post(`/goals/${goalId}/checklist-items/`, {
        title,
      });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível adicionar a tarefa.'),
      );
    }
  },

  async toggleChecklistItem(goalId, itemId) {
    try {
      const { data } = await apiClient.patch(
        `/goals/${goalId}/checklist-items/${itemId}/toggle/`,
        {},
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível actualizar a tarefa.'),
      );
    }
  },

  async deleteChecklistItem(goalId, itemId) {
    try {
      await apiClient.delete(`/goals/${goalId}/checklist-items/${itemId}/`);
      return APIResponse.success(null);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível remover a tarefa.'),
      );
    }
  },
};
